// PLQA-C-005: the pricing card and the Confirm-Upgrade/Downgrade modal used
// to derive a plan's "billed annually" total two different ways -- the card
// computed `Math.round(monthlyPrice * 12)` while the modal defaulted to a
// separately server-sourced annual figure. For the same tier those two
// numbers can legitimately disagree (e.g. 6.88 * 12 = 82.56, rounded to 83
// by the card vs a stored 82.5 on the modal side). Both surfaces now call
// this single helper so the same plan always shows the same annual total.
export const formatAnnualTotal = (monthlyPrice) => {
  const value = parseFloat(monthlyPrice) || 0;
  return (value * 12).toFixed(2);
};

